/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql } from '@apollo/client';
import { useCart } from '@exo/frontend-features-tdcart-logic';
import {
  renderDefaultError,
  renderDefaultLoading,
  SmartComponentProps
} from '@exo/frontend-common-utils';
import { useSessionContext } from '@exo/frontend-common-session-context';

export const PaymentMethodsContainer = ({
  cartId,
  render,
  renderError = renderDefaultError,
  renderLoading = renderDefaultLoading
}: Props) => {
  const { data, error, loading } = useCart<AvailablePaymentMethods>(
    { cartId },
    PaymentMethodsContainer.fragment
  );
  const session = useSessionContext();

  if (loading) return renderLoading();
  if (error) return renderError(error);
  const availablePaymentMethods = [
    { __typename: 'CrtPaymentMethod', id: 'Credit or debit card', identifier: 'Credit or debit card', description: 'Credit or debit card', type: 'TOKEN' }
  ]

  if(session.roles?.[0] !== 'guest'){
    availablePaymentMethods.unshift({ __typename: 'CrtPaymentMethod', id: 'TD bank account', identifier: 'TD bank account', description: 'TD bank account', type: 'TOKEN' })
  }


  return render({ availablePaymentMethods: availablePaymentMethods ?? [], cartId, grandTotal: data?.me?.carts[0]?.grandTotal, userId: data?.me?.id });
};

type Props = SmartComponentProps<{
  cartId: string;
  render: (props: PaymentMethodsContainerRenderProps) => JSX.Element | null;
}>;

export type PaymentMethodsContainerRenderProps = AvailablePaymentMethods;

type AvailablePaymentMethods = {
  availablePaymentMethods: {
    id: string;
    identifier: string;
    description?: string;
    type: string;
  }[];
  cartId: any;
  grandTotal: any;
  userId: any;
};

PaymentMethodsContainer.fragment = gql`
  fragment AvailablePaymentMethodsContainer on CrtCart {
    id
    grandTotal {
      value
      currency
    }
    ${process.env.APP_NAME !== 'TDCAPM' ? `availablePaymentMethods {
      id
      identifier
      description
      type
    }` : '# availablePaymentMethods not called for DPM app (TDCAPM)'}
  }
`;
